export default __webpack_public_path__ + "static/media/promo-harry-in-hiding_04.7241a580.jpg";